export default __webpack_public_path__ + "static/media/introdaily.9ac8233e.jpg";